module.exports = __webpack_public_path__ + "img/car_disabled.15c721ba.svg";